export default __webpack_public_path__ + "static/media/infinity_icon.0a710a26.svg";